/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl } from '../fetch-graphql';
import { UPDATE_CUSTOMER_EMAIL } from './graphql/updateCustomerEmail.graphql';
import { handleNetworkError } from '@/account/lib/network-error';
import { handleFetchError } from '@/account/lib/fetch-error';

export const updateCustomerEmail = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<string> => {
  return await fetchGraphQl(UPDATE_CUSTOMER_EMAIL, {
    method: 'POST',
    variables: { email, password },
  })
    .then((response) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return response?.data?.updateCustomerEmail?.customer?.email || '';
    })
    .catch(handleNetworkError);
};
